import { Injectable } from "@angular/core";
import { PublicHttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class PublicGpsService {
  constructor(private http: PublicHttpClientService) {}

  public with_display_data(gps_id: string | number): Observable<any> {
    return this.http
      .get(`/api/public/gps/${gps_id}/with_display_data`)
      .pipe(tap((_) => console.log("PublicGpsService.withDisplayData: Ok.")));
  }

  public perform(gps_id: string | number, action: string, params?: Record<string, unknown>): Observable<any> {
    const body = { gps_action: action, ...params };
    return this.http
      .post(`/api/public/gps/${gps_id}/perform`, body)
      .pipe(tap((_) => console.log("PublicGpsService.perform: Ok.")));
  }

  public getInstallationDetailsPdf(gps_id: string | number): Observable<any> {
    return this.http
      .get(`/api/public/gps/${gps_id}/installation_appointment_details`, { responseType: "blob" as "json" })
      .pipe(tap((_) => console.log("PublicGpsService.getInstallationDetailsPdf: Ok.")));
  }
}
